import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { Application } from '../models/application';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class ApplicationsService extends CrudService implements AdvancedService<Application> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<Application>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        if (context === null) {
            // Appel de la Web Api
            return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/applications`, httpOptions).pipe(
                map((x) => {
                    console.log('ApplicationsService List', x);
                    var res = Results.getCopyFrom<Application>(Application, x);
                    return res;
                })
            );
        } else {
            // Appel de la Web Api
            return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/Group/${context.value}/applications`, httpOptions).pipe(
                map((x) => {
                    var res = Results.getCopyFrom<Application>(Application, x);
                    return res;
                })
            );
        }
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/applications/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(applicationId: string, application: Application): Observable<Application> {
        // Appel de la Web Api
        return this.http.put<Application>(this.baseUrl + `/api/organizations/${this.organizationId}/applications/${applicationId}`, application, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    reset(applicationId: string): Observable<Application> {
        // Appel de la Web Api
        return this.http.delete<Application>(this.baseUrl + `/api/organizations/${this.organizationId}/applications/${applicationId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    add(application: Application): Observable<Application> {
        // Appel de la Web Api
        return this.http.post<Application>(this.baseUrl + `/api/organizations/${this.organizationId}/applications`, application, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    get(applicationId: string): Observable<Application> {
        // Appel de la Web Api
        return this.http.get<Application>(this.baseUrl + `/api/organizations/${this.organizationId}/applications/${applicationId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
